import { CommonModule, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-schedule-badge',
  standalone: true,
  imports: [CommonModule, NgClass],
  template: `
    <div
      class="flex h-8 w-8 items-center justify-center rounded-full text-center font-title text-[10px] 2xsm:text-[12px] font-normal leading-[18px] transition-all duration-300 2xsm:h-8 2xsm:w-auto 2xsm:min-w-[42px] 2xsm:px-1 xsm:h-9 xsm:min-w-[44px]"
      [ngClass]="{
        'bg-blue-light-200 text-blue-light-600': isPast() || !isCurrentMonth(),
        'bg-blue-light-500 text-white': !isPast()
      }"
    >
      {{ value() }}
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleBadgeComponent {
  value = input.required<string>();
  isPast = input<boolean>(false);
  isCurrentMonth = input<boolean>(true);
}
